/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import type { GanttViewportTaskLayoutObj } from './utils/dataLayoutUtils';
import { TimeComponentCanvas2D } from '../PRIVATE_TimeComponent';
import { drawTask } from './utils/canvasDrawUtils';

type Props<K2> = {
  width: number;
  height: number;
  layoutObj?: GanttViewportTaskLayoutObj<K2>;
};

export function GanttTaskHoverEffectsLayer<K2>({ width, height, layoutObj: taskObj }: Props<K2>) {
  const draw = (ctx: CanvasRenderingContext2D) => {
    taskObj && drawTask(ctx, taskObj, 'hovered');
  };
  return <TimeComponentCanvas2D width={width} height={height} draw={draw} />;
}
